export default "__VITE_ASSET__DurUrE74__"